export default "__VITE_ASSET__Bj$44d4k__"